import { Injectable } from '@angular/core';
import {from, Observable} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";
import {env} from "@environments/environment";
import {DocumentTypeInterface, DocumentTypeInterfaces} from "@app/quarantine/intrfaces/quarantine-form.interface";
import {
  createDocumentRemovalPayloadInterface,
  MedicinesMedicalDevicesInterface,
  OrganisationsInterface, QuarantineDocumentsPlacementRequestInterface, QuarantineDocumentsPlacementResponce,
  QuarantinePlacementInterface, UpdateDocumentQuarantinePlacementInterface
} from "@app/quarantine/intrfaces/quarantine.interface";

@Injectable({
  providedIn: 'root'
})
export class QuarantineApiService {

  constructor(
      private http: HttpClient
  ) { }

  public getDocumentTypes(): Observable<DocumentTypeInterfaces> {
    return this.http.get<DocumentTypeInterfaces>(env.apiUrl + '/accounting/v1/document/quarantine/type')
  }

  public getOrganizationTypes(): Observable<DocumentTypeInterfaces> {
    return this.http.get<DocumentTypeInterfaces>(env.apiUrl + '/accounting/v1/document/quarantine/organization')
  }
  
  

  public getOrganisations(): Observable<OrganisationsInterface> {
    return this.http.get<OrganisationsInterface>(env.apiUrl + '/accounting/v1/organization');
  }
  
  public getMedicinesMedicalDevices(config: {organizationId?: string|number[], tradeName: string}): Observable<MedicinesMedicalDevicesInterface> {
    let url = env.apiUrl + '/accounting/v1/medicines-medical-devices/filter/trade-name?';
    
    // @ts-ignore
    const params: string = new URLSearchParams(config).toString();
    return this.http.get<MedicinesMedicalDevicesInterface>(url + params)
  }
  
  public createQuarantinePlacement(data: QuarantinePlacementInterface) {
    return this.http.post<QuarantinePlacementInterface>(env.apiUrl + '/accounting/v1/document/quarantine/placement', data, {})
  }
  
  public getQuarantinePlacements(
      data: QuarantineDocumentsPlacementRequestInterface,
      params: {page: number, size: number, sort?: string[]}) {
    
    // @ts-ignore
    const queryParams = new URLSearchParams(params).toString();
    const url = env.apiUrl + '/accounting/v1/document/quarantine?' + queryParams;
    return this.http.post<QuarantineDocumentsPlacementResponce>(url , data, {})
  }
  
  public getQuarantinePlacement(id: string | number) {
    const url = env.apiUrl + `/accounting/v1/document/quarantine/${id}`;
    return this.http.get<QuarantineDocumentsPlacementResponce>(url)
  }
  
  public getQuarantineDocument(id: number, qParams: { page: number, size: number, sort?: string[] }) {
    // @ts-ignore
    const queryParams = new URLSearchParams(qParams).toString()
    let url = `accounting/v1/document/quarantine/placement/${id}/transaction?${queryParams}`
    return this.http.get<any>(env.apiUrl + url);
  }
  
  public getQuarantineDocumentRemoval(id: number, qParams: { page: number, size: number, sort?: string[] }) {
    // @ts-ignore
    const queryParams = new URLSearchParams(qParams).toString()
    let url = `accounting/v1/document/quarantine/removal/${id}/transaction?${queryParams}`
    return this.http.get<any>(env.apiUrl + url);
  }
  
  public updateDocumentQuarantinePlacement(data: UpdateDocumentQuarantinePlacementInterface) {
      return this.http.put<UpdateDocumentQuarantinePlacementInterface>(env.apiUrl + '/accounting/v1/document/quarantine/placement', data, {})
  }
  
  public canselDocumentQuarantinePlacement(id: any) {
      return this.http.post<any>(env.apiUrl + `/accounting/v1/document/quarantine/placement/${id}/cancel`, {})
  }
  
  public confirmDocumentQuarantinePlacement(id: any) {
      return this.http.post<any>(env.apiUrl + `/accounting/v1/document/quarantine/placement/${id}/confirm`, {})
  }
  
  public createDocumentQuarantineRemoval(data: createDocumentRemovalPayloadInterface) {
      return this.http.post<any>(env.apiUrl + `/accounting/v1/document/quarantine/removal`, data)
  }
  
  public updateDocumentQuarantineRemoval(data: createDocumentRemovalPayloadInterface) {
      return this.http.put<any>(env.apiUrl + `/accounting/v1/document/quarantine/removal`, data)
  }
  
  public canselDocumentQuarantineRemoval(id: any) {
    return this.http.post<any>(env.apiUrl + `/accounting/v1/document/quarantine/removal/${id}/cancel`, {})
  }
  
  public confirmDocumentQuarantineRemoval(id: any) {
    return this.http.post<any>(env.apiUrl + `/accounting/v1/document/quarantine/removal/${id}/confirm`, {})
  }
  
  public refreshTransactionPlacement(id: any) {
    return this.http.post<any>(env.apiUrl + `/accounting/v1/document/quarantine/placement/${id}/transaction/refresh`, {})
  }
}
